import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';
import { FILTER_COLOR } from './filter-colors';

const INCLUDE_OPTIONS = ['ACTIVE', 'ARCHIVED', 'ALL'] as const;

export const leadIncludeFilterConfig = createSimpleFilterConfig({
  facetName: 'include',
  color: FILTER_COLOR.slate,
  options: INCLUDE_OPTIONS.map((option) => ({
    label: formatTextForDisplay(option),
    value: option,
  })),
});
